<template>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2 class="text-left">{{$tc('regulation.family', 1)}}</h2>

                <LayoutCard :title="$tc('regulation.family', 1)" active="true">
                    <div class="loader" v-if="loading">

                    </div>

                    <fieldset :disabled="loading">
                        <form @change="save()">
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="input">{{ $t('general.name') }}</label>
                                    <b-form-input v-can:input="'Update_Family'" type="text" class="form-control" id="input" :state="validateState($v.objectData.name)" :placeholder="$t('general.name')" v-model="objectData.name" @input="getFamiliesName(objectData.name)" :trim="true" />
                                    <div class="invalid-feedback" v-if="!$v.objectData.name.isNameUnique">This name already exist</div>
                                </div>
                            </div>
                        </form>
                    </fieldset>

                </LayoutCard>

                <div v-if="isMod">
                    <SaveCancelDeleteButtons permission="Create_Family" @clicked="getClicked" @isMod="isMod" :isError="$v.$anyError"></SaveCancelDeleteButtons>
                </div>

                <div class="fixed-top mt-3 d-flex justify-content-center">
                    <b-alert :show="dismissCountDown" dismissible fade :variant="alertType" @dismiss-count-down="countDownChanged">
                        {{ feedbackMessage }}
                    </b-alert>
                </div>

            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from 'axios'
import LayoutCard from '../components/LayoutCard.vue'
import SaveCancelDeleteButtons from '../components/SaveCancelDeleteButtons.vue'

import Feedback from '../mixins/Feedback.js'
import CommonVariablesAndFunctions from '../mixins/CommonVariablesAndFunctions.js'

function isNameUnique(value) {
    if (this.families.filter(e => e.name.toLowerCase() === value.toLowerCase()).length == 0) {
        return true
    }
    return false
}

window.axios = require("axios");

export default {
    name: 'Family',

    mixins: [Feedback, CommonVariablesAndFunctions],

    components: {
        LayoutCard,
        SaveCancelDeleteButtons,
    },

    data() {
        return {
            title: "Family",
            endpoint: "family",
            value: "",

            objectData: {
                addBy: "",
                addDate: "",
                modBy: "",
                modDate: null,
                name: "",
            },

            families: []
        };
    },
    methods: {

        getData() {
            this.loading = true;
        },

        processForm() {

            let family = {
                name: this.objectData.name,
            };
            return family
        },

        postData(endpoint, data) {
            axios
                .post(endpoint, data)
                .then(() => {
                    this.isMod = false
                    this.succesAlert()
                    this.$router.push('/regulations/families');
                })
                .catch((error) => {
                    this.errorAlert(error)
                })
        },

        async getFamiliesName(input) {
            if (input.length > 1) {
                var filter = "/search/findByNameContainingIgnoreCase";
                var paramValue = {
                    "name": input,
                };
                let response = await axios.get("family" + filter, {
                    params: paramValue
                })
                this.families = response.data._embedded.family;
            }
        },

    },

    created() {
        if (this.$route.params.id) {
            this.getData();
        } else {
            this.loading = false;
        }
    },

    validations: {
        objectData: {
            name: {
                isNameUnique
            }
        }

    }
};
</script>

<style scoped>
.form-group {
    text-align: left;
    font-weight: bold;
}
</style>
